import BaseCard from './BaseCard';
import { CardType } from './CardType';

export default class BoomCard extends BaseCard {
    public onCreate(params: any): void {
        params.cardFrontTexture = 'boom_card';
        params.type = CardType.boom;
        super.onCreate(params);
    }
}
